// SQL Workplace 持久化 key 的安全掃除。
//   現行 key 為 `sql-workplace:v1:{code}`；舊版帶產品線 `sql-workplace:v1:{code}:{product}`，以及更早的
//   `sql-workplace:v1`。本函式把「不屬於目前登入者」的 key 全部清掉：
//   - 換帳號：B 登入後 A 的殘留立即清除（B 的資料保留）
//   - 登出（或任何無登入資訊的時刻）：currentCode 為 null → 全部清除
//   目前登入者的 `:Live-Asia` 舊 key 刻意保留，由 store/workspace.js 載入時搬到現行 key（搬完刪除）；
//   其他產品線的舊 key 無人會搬，直接清掉。
//   誤刪無虞：後端 options（Redis、session 隔離）存有同形狀 blob，下次登入 hydrate 會還原。
//   刻意零依賴（僅 import 常數），供 index.jsx 開機與 workspace.js 載入時共用，不拖入 store。
import { STORAGE_KEY_PREFIX } from '../constants'

const LEGACY_PRODUCT = 'Live-Asia'

function isKept(key, currentCode) {
  if (!currentCode) return false
  const current = `${STORAGE_KEY_PREFIX}:${currentCode}`
  return key === current || key === `${current}:${LEGACY_PRODUCT}`
}

export function sweepWorkspaceStorage(currentCode) {
  try {
    // 先收集再刪：迭代中 removeItem 會位移 localStorage.key(i) 的索引
    const doomed = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k === STORAGE_KEY_PREFIX || (k?.startsWith(`${STORAGE_KEY_PREFIX}:`) && !isKept(k, currentCode))) doomed.push(k)
    }
    doomed.forEach((k) => localStorage.removeItem(k))
  } catch {
    /* 忽略隱私模式 / 存取受限錯誤 */
  }
}

// 把 `<key>:Live-Asia` 搬到 `<key>`：新 key 不存在才搬，搬完（或新 key 已在）刪舊 key。
// sweep 對目前登入者的 Live-Asia 舊 key 刻意放行，就是留給這裡搬。
export function migrateLegacyWorkspaceKey(key) {
  const legacyKey = `${key}:${LEGACY_PRODUCT}`
  try {
    const legacy = localStorage.getItem(legacyKey)
    if (legacy === null) return
    if (localStorage.getItem(key) === null) localStorage.setItem(key, legacy)
    localStorage.removeItem(legacyKey)
  } catch {
    /* 忽略隱私模式 / quota 錯誤：搬不成就當沒有舊資料 */
  }
}
